require('jquery');
import {laravelRoute} from "./util/common";

import {getVehicleNextPrev, handleVehicleNextPrev} from '../js/util/common'
$(function () {
    let keysPressed = {};
    let keyMap = {
        'h': '/',
        'a': laravelRoute('auction'),
        'v': laravelRoute('recommended.index'),
        'r': laravelRoute('recentSearch.index'),
        'f': laravelRoute('favourites.index'),
        // 'c': laravelRoute('currency-calculator'), //this is handled in resources/js/components/CurrencyCalculator.vue
        'b': laravelRoute('user-bid.index'),
        'm': laravelRoute('my-garage.index'),
        'p': laravelRoute('auctions.marketResearch'),
        's': laravelRoute('saved-search.index'),
        'n': laravelRoute('auto-notices.index'),
        //'l': laravelRoute('makes.index'),
        'x': laravelRoute('manage'),
        'u': laravelRoute('users.index'),
    };

    window.addEventListener('keydown', function (e) {
        if (e.key) {
            let key = e.key.toLowerCase()
            if (!$(e.target).is(':input')) {
                if (keyMap[key] && !e.metaKey) {
                    let currentDate = new Date();
                    let currentTime = currentDate.getTime();
                    if (keysPressed[key] && currentTime - keysPressed[key] < 500) {
                        window.location.href = keyMap[key];
                        return;
                    }
                    keysPressed[key] = currentTime;
                }
            }
        }

    });

});



// WEBPACK FOOTER //
// ./resources/js/hotkeys.js